import React from 'react';
import styled from 'styled-components/macro';

export const Wrapper = styled.svg`
  height: 100%;
  width: 100%;
`;

const Exclamation = () => (
  <Wrapper
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width={512} height={512}
    x={0} y={0}
    viewBox="0 0 512 512"
    style={{ enableBackground: 'new 0 0 512 512' } as React.CSSProperties}
    xmlSpace="preserve"
  >
    <circle
      r={256} cx={256} cy={256}
      fill="#ffffff"
      transform="matrix(0.85,0,0,0.85,38.400000000000006,38.400000000000006)"
    />
    <g transform="matrix(1,0,0,1,0,0)">
      <g xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            d="M256,0C115.2,0,0,115.2,0,256s115.2,256,256,256s256-115.2,256-256S396.8,0,256,0z M256,51.2   
               c28.16,0,48.64,23.04,46.08,51.2L281.6,307.2h-51.2l-20.48-204.8C207.36,74.24,227.84,51.2,256,51.2z M256,460.8    
               c-28.16,0-51.2-23.04-51.2-51.2c0-28.16,23.04-51.2,51.2-51.2s51.2,23.04,51.2,51.2C307.2,437.76,284.16,460.8,256,460.8z"
            fill="var(--theme-danger)"
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
      <g xmlns="http://www.w3.org/2000/svg">
      </g>
    </g>
  </Wrapper>
);

export default Exclamation;